import { c as _c } from "react/compiler-runtime";
import type { MissingCardPaymentModel } from "../../domain/models/MissingCardPayment";
import type { SearchFilter, SearchInclude, SearchScope, SearchSort } from "../../domain/models/http/SearchRequest";
import { missingCardPaymentQuery } from "../../services/payments/MissingCardPaymentQueryService";
import { queryKeys } from "@/utils/queryKeys";
import useCustomPaginateQuery from "./useCustomPaginateQuery";
const MISSING_CARD_PAYMENT_INCLUDES: SearchInclude[] = [{
  relation: "plaque"
}, {
  relation: "site"
}, {
  relation: "subsidiary"
}, {
  relation: "activities"
}, {
  relation: "activities.causer"
}];
const DEFAULT_SORT: SearchSort[] = [{
  field: "document_date",
  direction: "desc"
}];
type UseMissingCardPaymentsParams = {
  filters?: SearchFilter[];
  scopes?: SearchScope[];
  sorts?: SearchSort[];
  page: number;
  limit: number;
  enabled?: boolean;
};
export const useMissingCardPayments = t0 => {
  const $ = _c(19);
  const {
    filters: t1,
    scopes: t2,
    sorts,
    page,
    limit,
    enabled: t3
  } = t0;
  let enabled;
  let filters;
  let scopes;
  let t4;
  let t5;
  if ($[0] !== limit || $[1] !== page || $[2] !== sorts || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    filters = t1 === undefined ? [] : t1;
    scopes = t2 === undefined ? [] : t2;
    enabled = t3 === undefined ? true : t3;
    t5 = useCustomPaginateQuery;
    t4 = queryKeys.payments.missingCardPayments({
      filters,
      scopes,
      sorts,
      page,
      limit
    });
    $[0] = limit;
    $[1] = page;
    $[2] = sorts;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = enabled;
    $[7] = filters;
    $[8] = scopes;
    $[9] = t4;
    $[10] = t5;
  } else {
    enabled = $[6];
    filters = $[7];
    scopes = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  const t6 = sorts && sorts.length > 0 ? sorts : DEFAULT_SORT;
  let t7;
  if ($[11] !== enabled || $[12] !== filters || $[13] !== limit || $[14] !== page || $[15] !== scopes || $[16] !== t4 || $[17] !== t6) {
    t7 = {
      queryKey: t4,
      request: missingCardPaymentQuery,
      includes: MISSING_CARD_PAYMENT_INCLUDES,
      filters,
      scopes,
      sorts: t6,
      page,
      limit,
      enabled
    };
    $[11] = enabled;
    $[12] = filters;
    $[13] = limit;
    $[14] = page;
    $[15] = scopes;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t5(t7);
};